'use client'

import { Button, ButtonSize, ButtonVariant, Icon, IconComponent } from '@graftcode/design-system'

import { MAIN_CONTENT_HEADER_TEST_IDS } from '@common/common-test-ids.const'

import { type MainContentHeaderProps } from './MainContentHeader.types'

import styles from './MainContentHeader.module.scss'

export function MainContentHeader({
  title,
  description,
  actionButtonLabel,
  actionButtonIcon,
  showRefreshButton = true,
  showActionButton = true,
  onRefreshClick,
  onActionClick,
}: MainContentHeaderProps) {
  return (
    <div className={styles.wrapper} data-testid={MAIN_CONTENT_HEADER_TEST_IDS.root}>
      <div className={styles.leftSection}>
        <div className={styles.titleRow}>
          <h1 className={styles.title}>{title}</h1>
          {showRefreshButton && (
            <button type="button" className={styles.refreshButton} onClick={onRefreshClick} aria-label="Refresh">
              <IconComponent icon={Icon.ArrowClockwiseFilled} className={styles.refreshIcon} />
            </button>
          )}
        </div>
        {description && <p className={styles.description}>{description}</p>}
      </div>

      {showActionButton && actionButtonLabel && (
        <Button
          className={styles.actionButton}
          variant={ButtonVariant.Secondary}
          size={ButtonSize.L}
          text={actionButtonLabel}
          icon={actionButtonIcon || Icon.AddFilled}
          iconPlacement="left"
          onClick={onActionClick}
        />
      )}
    </div>
  )
}
